import localeCore from "../../core/locale.core";
import useGetBrand from "../../hooks/useGetBrand.hook";
import ErrorCenterIcon from "../../icons/exclamationTriangleCenter.icon";
import LoadingOvalIcon from "../../icons/loadingOval.icon";

export default function BrandName({ brandId }: { brandId: string }) {
  const { data: brand, isPending, isError, error } = useGetBrand(brandId);

  if (isPending) return <LoadingOvalIcon />;
  if (isError) return <ErrorCenterIcon reason={error.message} />;
  if (!brand) return null;

  return <span data-label={`brand-${brand.code}`}>{localeCore.getLocaleValueDefaultFallback(brand.name)}</span>;
}
